import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TrustBar from '../../components/feature/TrustBar';
import ProcessSection from '../../components/feature/ProcessSection';
import WhyChooseUs from '../../components/feature/WhyChooseUs';
import TestimonialsSection from '../../components/feature/TestimonialsSection';
import FAQSection from '../../components/feature/FAQSection';
import FinalCTA from '../../components/feature/FinalCTA';
import AIAnswerBlock from '../../components/feature/AIAnswerBlock';
import ServiceAreasSection from '../../components/feature/ServiceAreasSection';
import HeroSection from './components/HeroSection';
import ServicesOverview from './components/ServicesOverview';
import { HOME_FAQS } from '../../mocks/siteData';

export default function HomePage() {
  return (
    <div className="font-sans">
      <Navbar />

      {/* 1. Hero */}
      <HeroSection />

      {/* 2. Trust Bar */}
      <TrustBar />

      {/* 3. Services Overview */}
      <ServicesOverview />

      {/* 4. AI Answer Block */}
      <AIAnswerBlock
        question="What Does Bay City Remodeling Do?"
        answer="Bay City Remodeling & Bathrooms LLC specializes in residential renovation projects including kitchens, bathrooms, and full-home remodels in Brandon, FL and surrounding communities. The company focuses on high-quality craftsmanship, functional design, and long-term durability. Services are tailored to homeowners looking to upgrade their living space with modern layouts, premium finishes, and improved usability — all backed by 18+ years of local experience and a 5.0-star reputation."
        bullets={[
          'Kitchen remodeling — custom layouts, cabinetry, and material selection',
          'Bathroom remodeling — spa-level finishes and efficient modern layouts',
          'Full home renovations — cohesive design and execution throughout the entire home',
          'Interior upgrades — flooring, trim, custom cabinetry, and layout improvements',
          'Serving Brandon, Riverview, Tampa, Valrico, and 20+ surrounding communities',
        ]}
      />

      {/* 5. Process */}
      <ProcessSection />

      {/* 6. Why Choose Us */}
      <WhyChooseUs />

      {/* 7. Service Areas */}
      <ServiceAreasSection />

      {/* 8. Testimonials */}
      <TestimonialsSection />

      {/* 9. FAQ */}
      <FAQSection
        faqs={HOME_FAQS}
        title="Remodeling Questions Answered"
      />

      {/* 10. Final CTA */}
      <FinalCTA />

      <Footer />
    </div>
  );
}
